/* src/app/modules/shared/components/header-column/header-column-aroma/header-column-aroma.component.scss */
app-header-column-aroma {
  display: contents;
}
/*# sourceMappingURL=header-column-aroma.component.css.map */
